export default __webpack_public_path__ + "static/media/shape-1.14eac045.svg";